import { Button, Form, Input } from 'antd';
import { putApi } from 'apis';
import { FORMDATA } from 'constants/Data';
import React, { FC, useState } from 'react';
import { toastText } from 'utils/utils';
import styles from './index.module.scss';
import { SideDrawerBodyProps } from './types';

const AddDeviceBody: FC<SideDrawerBodyProps> = (props) => {
	// Inits
	const { addDeviceFields } = FORMDATA;
	const { closeDrawerByAnimation, editSelectedDevice, fetchDevices } = props;
	const [form] = Form.useForm();

	const [loading, setLoading] = useState<boolean>();

	const editData = {
		...editSelectedDevice,
		fullName: editSelectedDevice?.name || '',
	};

	const onFinish = async (values: any) => {
		try {
			setLoading(true);
			 await putApi(`/devices/${editData?.id}`, values).then((res) => {
				if (res?.data?.responseStatus === 200) {
					toastText(res?.data?.message, 'success');
				}
			});
		} catch (error: any) {
			toastText(error?.response?.data?.message, 'error');
		}finally {
			setLoading(false);
			fetchDevices()
			closeDrawerByAnimation()
			form.resetFields();
		}
	};

	// JSX
	return (
		<div className={styles['side-drawer-body']}>
			<Form
				form={form}
				name="basic"
				initialValues={editData}
				onFinish={onFinish}
				autoComplete="off"
				layout="vertical"
				labelAlign="left"
				className={styles['side-drawer-form']}
			>
				<div className={styles['side-drawer-form__inputs']}>
					{addDeviceFields.map((singleField: any, index: number) => {
						return (
							<React.Fragment key={index}>
								<Form.Item
									label={singleField?.title}
									name={singleField.name}
									rules={singleField.rules}
									className="side-drawer-form__role"
									labelCol={{ span: 24 }} // Optional: Makes label full-width
								>
									<Input disabled={singleField?.id === "macAddress"}/>
								</Form.Item>

							</React.Fragment>
						);
					})}
				</div>
				<div className={styles['side-drawer-form__buttons']}>
					<Button
						htmlType="submit"
						className={styles['side-drawer-form__buttons--edit']}
						loading={loading} //loading
					>
						{editSelectedDevice ? 'Edit' : 'Save'}
					</Button>

					<Button
						htmlType="reset"
						className={styles['side-drawer-form__buttons--cancel']}
						disabled={loading}
						onClick={closeDrawerByAnimation}
					>
						Cancel
					</Button>
				</div>


			</Form>
		</div>
	);
};

export default AddDeviceBody;
